import { IPersonRevenue, ITarget } from '../Client/ITarget'

export const GET_PERSON_REVENUES_REQUEST = 'GET_PERSON_REVENUES_REQUEST'
export const GET_PERSON_REVENUES_SUCCESS = 'GET_PERSON_REVENUES_SUCCESS'
export const GET_PERSON_REVENUES_FAILURE = 'GET_PERSON_REVENUES_FAILURE'

export const GET_PERSON_TARGETS_REQUEST = 'GET_PERSON_TARGETS_REQUEST'
export const GET_PERSON_TARGETS_SUCCESS = 'GET_PERSON_TARGETS_SUCCESS'
export const GET_PERSON_TARGET_FAILURE = 'GET_PERSON_TARGET_FAILURE'

export const DELETE_PERSON_TARGET_REQUEST = 'DELETE_PERSON_TARGET_REQUEST'
export const DELETE_PERSON_TARGET_SUCCESS = 'DELETE_PERSON_TARGET_SUCCESS'
export const DELETE_PERSON_TARGET_FAILURE = 'DELETE_PERSON_TARGET_FAILURE'

export const UPDATE_PERSON_TARGET_REQUEST = 'UPDATE_PERSON_TARGET_REQUEST'
export const UPDATE_PERSON_TARGET_SUCCESS = 'UPDATE_PERSON_TARGET_SUCCESS'
export const UPDATE_PERSON_TARGET_FAILURE = 'UPDATE_PERSON_TARGET_FAILURE'

export const CREATE_PERSON_TARGET_REQUEST = 'CREATE_PERSON_TARGET_REQUEST'
export const CREATE_PERSON_TARGET_SUCCESS = 'CREATE_PERSON_TARGET_SUCCESS'
export const CREATE_PERSON_TARGET_FAILURE = 'CREATE_PERSON_TARGET_FAILURE'

interface GetPersonRevenuesAction {
  type: typeof GET_PERSON_REVENUES_REQUEST
}

interface GetPersonRevenuesSuccess {
  type: typeof GET_PERSON_REVENUES_SUCCESS
  payload: {
    personRevenues: IPersonRevenue[]
  }
}

interface GetPersonRevenuesFailure {
  type: typeof GET_PERSON_REVENUES_FAILURE
}

interface GetPersonTargetsAction {
  type: typeof GET_PERSON_TARGETS_REQUEST
}

interface GetPersonTargetsSuccess {
  type: typeof GET_PERSON_TARGETS_SUCCESS
  payload: {
    personTargets: ITarget[]
  }
}

interface GetPersonTargetFailure {
  type: typeof GET_PERSON_TARGET_FAILURE
}

interface CreatePersonTargetAction {
  type: typeof CREATE_PERSON_TARGET_REQUEST
}

interface CreatePersonTargetSuccess {
  type: typeof CREATE_PERSON_TARGET_SUCCESS
  payload: {
    personTarget: ITarget
  }
}

interface CreatePersonTargetFailure {
  type: typeof CREATE_PERSON_TARGET_FAILURE
  errors: any
}

interface DeletePersonTargetAction {
  type: typeof DELETE_PERSON_TARGET_REQUEST
}

interface DeletePersonTargetSuccess {
  type: typeof DELETE_PERSON_TARGET_SUCCESS
  payload: {
    personTarget: ITarget
  }
}

interface DeletePersonTargetFailure {
  type: typeof DELETE_PERSON_TARGET_FAILURE
}

interface UpdatePersonTargetAction {
  type: typeof UPDATE_PERSON_TARGET_REQUEST
}

interface UpdatePersonTargetSuccess {
  type: typeof UPDATE_PERSON_TARGET_SUCCESS
  payload: {
    oldPersonTarget: ITarget
    newPersonTarget: ITarget
  }
}

interface UpdatePersonTargetFailure {
  type: typeof UPDATE_PERSON_TARGET_FAILURE
  errors: any
}

export type ActionTypes =
  | GetPersonRevenuesAction
  | GetPersonRevenuesSuccess
  | GetPersonRevenuesFailure
  | GetPersonTargetsAction
  | GetPersonTargetsSuccess
  | GetPersonTargetFailure
  | CreatePersonTargetAction
  | CreatePersonTargetSuccess
  | CreatePersonTargetFailure
  | DeletePersonTargetAction
  | DeletePersonTargetSuccess
  | DeletePersonTargetFailure
  | UpdatePersonTargetAction
  | UpdatePersonTargetSuccess
  | UpdatePersonTargetFailure
